<ng-container *ngIf="shelf.gridConfig?.format == 'BLOCK'">
    <div class="grid-container" [ngStyle]="{
          'grid-template-columns': 'repeat(' + shelf.gridConfig?.itemsPerRow + ', 1fr)'
        }">
      <div *ngFor="let img of shelf.images" [ngClass]="['grid-item', shelf.gridConfig?.shape?.toLowerCase()]"
        (click)="redirect(img.redirectUrl)" [style.height]="gridLineHeight">
        <img [src]="img.url" [alt]="img.alt" />
      </div>
    </div>
  </ng-container>
  <ng-container *ngIf="shelf.gridConfig?.format == 'INLINE'">
    <div class="grid-inline-wrapper">
      <div class="grid-container-inline" [style.height]="gridInlineContainerHeight">
        <div class="inline-track" [style.transform]="'translateX(-' + (currentInlinePage * 100) + '%)'"
          [style.height]="gridLineHeight">
          <div *ngFor="let img of shelf.images" class="grid-item" [ngClass]="shelf.gridConfig?.shape?.toLowerCase()"
            (click)="redirect(img.redirectUrl)" [style.height]="gridLineHeight">
            <img [src]="img.url" [alt]="img.alt" />
          </div>
        </div>
      </div>
      <div class="arrow-button next" (click)="nextInlinePage()" *ngIf="currentInlinePage != lastInlinePage">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <path d="M10 6 8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z" />
        </svg>
      </div>
      <div class="arrow-button prev" (click)="prevInlinePage()" *ngIf="currentInlinePage != 0">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <path d="M14 6l1.41 1.41L9.83 12l4.58 4.59L14 18l-6-6z" />
        </svg>
      </div>
    </div>
  </ng-container>